import classnames, { Argument } from "classnames";

// A simple wrapper around classNames to return null, if no classes were generated
// Otherwise, original classNames returns empty string which causes class="" to be generated
const classNames = (...args: Argument[]): string | undefined => {
  return classnames.call(this, ...args) || undefined;
};
export default classNames;
